import React, {Component} from 'react';

export default class Card extends Component {
    render() {
        const {image, header, body, postBody} = this.props;

        return (
            <div className="card">
                <div className="card-image">
                    <img src={image}/>
                </div>
                <div className="card-body">
                    <h2>{header}</h2>
                    {body}
                    {!postBody || <div className="card-post-body">{postBody}</div>}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./web/js/components/card.js